import { AppRoutes } from "AppRoutes";
import { createLogger } from "logging";
import { BoardViewModel } from "models/BoardViewModel";
import { RunModel } from "models/RunModel";
import { TranslationLabels } from "translations/TranslationLabels";

import { formatDate, formatTime } from "./dates";
import { stripHtmlTags } from "./utils";

const logger = createLogger("MailTextHelper");

export function replaceEmailPlaceholders(emailTemplate: string, replacements: Record<string, string>) {
  return emailTemplate.replace(/{{(.*?)}}/g, (_, placeholder) => {
    return replacements[`{{${placeholder}}}`] || "";
  });
}

export function getEmailPlaceholders(
  i18n: TranslationLabels,
  run?: RunModel,
  board?: BoardViewModel,
  boardOwner?: string
): Record<string, string> {
  const { protocol, host } = window.location;
  const baseUrl = `${protocol}//${host}`;

  const replacements: Record<string, string> = {
    "{{boardName}}": board?.name || "",
    "{{runTitle}}": run?.title || "",
    "{{expiryDate}}": formatDate(run?.expiryDate) || "",
    "{{expiryTime}}": formatTime(run?.expiryDate) || "",
    "{{boardOwnerName}}": boardOwner || i18n.BoardRole_Owner,
    "{{voteLink}}": baseUrl + AppRoutes.toVoting(board?.id, run?.id),
  };
  return replacements;
}
export function getEmailText(emailTemplate: string, replacements: Record<string, string>) {
  const value = replaceEmailPlaceholders(emailTemplate, replacements);
  logger.debug(`getEmailText(): `, emailTemplate, value);
  return value;
}

export const getEmailSubject = (emailTemplate: string, replacements: Record<string, string>): string => {
  let value = replaceEmailPlaceholders(emailTemplate, replacements);
  value = stripHtmlTags(value);
  logger.debug(`getEmailSubject(): `, emailTemplate, value);
  return value;
};
